'use client';

import { APIProvider, Map as GoogleMap, Marker } from '@vis.gl/react-google-maps';

import { useGetContent } from '@/lib/react-query/ContentQueries';

type Props = {
  height?: string;
};

const Map = ({ height }: Props) => {
  const { data: content, error, isLoading } = useGetContent();

  if (isLoading || !content) {
    return null;
  }

  const coordinates = {
    lat: content.google?.maps_coordinate_lat,
    lng: content.google?.maps_coordinate_lng,
  };

  if (error) return <div>Error loading map data</div>;

  if (!coordinates.lat || !coordinates.lng) {
    return null;
  }

  return (
    <APIProvider apiKey="AIzaSyAPZ-f2AipzbCfSFcEywO-LlR4zmBrF8YM">
      <GoogleMap
        style={{ width: '100%', height: '100%' }}
        className={height}
        defaultCenter={{
          lat: coordinates.lat,
          lng: coordinates.lng,
        }}
        defaultZoom={18}
        gestureHandling="cooperative"
        mapId="terrain"
        disableDefaultUI={true}
      >
        <Marker
          position={{
            lat: coordinates.lat,
            lng: coordinates.lng,
          }}
        />
      </GoogleMap>
    </APIProvider>
  );
};

export default Map;
